// Constants
export const WIDTH = 4000;
export const MARGIN = 25;

export const TEAM_HEIGHT = 75;
